import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {SearchRequestModel} from '../../shared/dto/search-request.model';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {Router} from '@angular/router';
import {SearchRequestDetailModel} from '../../shared/dto/search-request-detail.model';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import swal from 'sweetalert2';
import {WorkflowStageEnum} from '../../shared/enums/workflow-stage.enum';
import {StageChangeService} from '../../service/stage-change.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StageChangePopupComponent} from './stage-change-popup/stage-change-popup.component';

/*
    Author - Sajith Henarath
    sajith_h@epiclanka.net
*/

@Component({
  selector: 'app-stage-change-mgt',
  templateUrl: './stage-change-mgt.component.html',
  styleUrls: ['./stage-change-mgt.component.scss']
})
export class StageChangeMgtComponent implements OnInit, AfterViewInit {

  public dateTimeRange: Date[] = [];
  public requestForm: FormGroup;
  public searchReqDTOList: SearchRequestModel[] = [];
  public max = new Date();
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  displayedColumns: string[] = ['requestId', 'applicantType', 'name','mobileNo', 'cdcNo' ,'cocNo','date','status', 'action'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  public item: SearchRequestModel[] = [];
  public workflowEnum = WorkflowStageEnum;

  constructor(public modalService: NgbModal,
              private stageChangeService: StageChangeService,
              private tokenStorageService: TokenStorageService,
              private router: Router,
              private spinnerService : NgxUiLoaderService) { }

  ngOnInit() {
    this.requestForm = new FormGroup({
      refNo: new FormControl(null),
      cdcNo: new FormControl(null),
      cocNo: new FormControl(null),
      sidNo: new FormControl(null),
      dateTimeRange: new FormControl(null),
      status: new FormControl(null),
      biometricStatus: new FormControl(null),
      dataverification: new FormControl(null)
    });

    this.loadAllRequests();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  loadAllRequests() {
    this.stageChangeService.getAllEligibleRequests().subscribe(
      (response: SearchRequestModel[]) => {
        this.searchReqDTOList = response;
        this.item = response;
        this.dataSource = new MatTableDataSource(this.searchReqDTOList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    )
  }

  onClickReset() {
    this.requestForm.reset({
      refNo: null,
      cdcNo: null,
      cocNo: null,
      dateTimeRange: [],
    });

    this.loadAllRequests();
  }

  onSubmitSearch(form: FormGroup) {
    let date: string[];
    date = form.value.dateTimeRange;

    if (date === null) {
      date = [];
    }

    const searchRequestDTO = new SearchRequestDetailModel(form.value.refNo,
      form.value.cdcNo, form.value.cocNo, date, form.value.status, form.value.biometricStatus,
      form.value.dataverification, form.value.sidNo);

    this.loadSearchResultList(searchRequestDTO);
  }

  onStageChangeBtnPopup(Item) {
    const modalRef = this.modalService.open(StageChangePopupComponent, {
      windowClass: "xlModal"
    });

    modalRef.componentInstance.name = "Change Stage";
    modalRef.componentInstance.flowDescription = Item.status;
    modalRef.componentInstance.flowCode = Item.appSts;
    modalRef.componentInstance.requestId = Item.requestId;
    modalRef.componentInstance.applicantName = Item.name;
    modalRef.componentInstance.cdcNo = Item.cdcNo;
    modalRef.result.then(
      (data: string) => {
        if (data == "Updated") {
          this.onClickReset();
        }
      },
      () => {}
    );
  }

  loadSearchResultList(searchRequestDTO: SearchRequestDetailModel) {
    this.spinnerService.start();

    this.stageChangeService.searchRequestDetails(searchRequestDTO).subscribe(
      (response: SearchRequestModel[]) => {
        this.searchReqDTOList = response;
        this.dataSource = new MatTableDataSource(this.searchReqDTOList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();

        if (this.searchReqDTOList == null || this.searchReqDTOList.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');
          this.loadAllRequests();
        } else {
          this.stageChangeService.clearRequestSearchDetails();
          this.stageChangeService.setRequestSearchDetails(this.searchReqDTOList);
        }
      }
    );
  }

}
